import { api } from '@/lib/api'
import type { AuditLogPage } from './types'

export async function listAuditLog(
  contractId: number,
  offset = 0,
  limit = 100,
): Promise<AuditLogPage> {
  const r = await api.get<AuditLogPage>(`/api/contracts/${contractId}/audit-log`, {
    params: { offset, limit },
  })
  return r.data
}
